import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Form, { FormTextField, FormDateTimeSelector, FormRichTextEditor } from '@ts-core/core/components/FormV2';

import { ProfessorActivity, ActivityInput } from '../../types';

const ActivityFormSchema = Yup.object({
  name: Yup.string().required(),
  statement: Yup.string(),
  deadline: Yup.date().nullable().min(new Date(), 'La fecha límite debe ser en el futuro').required('Debes especificar una fecha límite'),
});

interface ActivityFormProps {
  activity: ProfessorActivity;
  loading?: boolean;

  onSubmit: (data: ActivityInput) => void;
  submitting: boolean;
  submitError?: string;
}

const ActivityForm = (props: ActivityFormProps) => {
  const { onSubmit, activity, loading = false, submitting, submitError } = props;
  const [isFormBusy, setIsFormBusy] = useState(false);

  const { handleSubmit, formState, control } = useForm<ActivityInput>({
    defaultValues: activity,
    resolver: yupResolver(ActivityFormSchema),
  });

  return (
    <Box width={{ xs: '100%', md: '50%' }}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        isSubmitting={submitting}
        submitError={submitError}
        formState={formState}
        loading={loading}
        disabled={isFormBusy}
      >
        <Grid container spacing={2} direction="column">
          <Grid item xs={12}>
            <FormTextField name="name" control={control} rules={{ required: true }} fullWidth label="Nombre" />
          </Grid>
          <Grid item xs={12}>
            <FormDateTimeSelector
              name="deadline"
              label="Fecha Límite"
              rules={{ required: true }}
              control={control}
              DateTimePickerProps={{
                disablePast: true,
                ampm: false,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormRichTextEditor name="statement" control={control} onBusyStatsChange={setIsFormBusy} />
          </Grid>
        </Grid>
      </Form>
    </Box>
  );
};

ActivityForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  activity: PropTypes.object,
  loading: PropTypes.bool,

  submitting: PropTypes.bool,
  submitError: PropTypes.string,
};

ActivityForm.defaultProps = {
  activity: {},
  loading: false,
  submitting: false,
  submitError: undefined,
};

export default ActivityForm;
